import { Component, OnInit } from '@angular/core';

import { MajorFooter } from '../../core/constants/major-footer.constant';
import { ParmedFooter } from '../../core/constants/parmed-footer.constant';
import { Footer } from '../../shared/models/footer';
import { AppCacheService } from '../../core/services/cache/app-cache.service';
import { CacheConstant } from '../../core/constants/app.constant';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BaseComponent } from '../../app.base.component';
import { AppConfigService } from '../../core/services/init/app-config.service';


@Component({
  selector: 'par-under-maintenance',
  templateUrl: './under-maintenance.component.html',
  styleUrls: ['./under-maintenance.component.scss']
})
export class UnderMaintenanceComponent extends BaseComponent implements OnInit {
  
  websiteName: string = this.cache.get(CacheConstant.Env_Properties).theme;
  entity =  `${this.websiteName +'Footer'}`;
  footerData : Footer;
  constructor(private cache: AppCacheService, deviceDetectorService: DeviceDetectorService, private appConfig: AppConfigService) {
    super(deviceDetectorService, cache, appConfig);
    this.footerData = super.getFooterData();
   // this.footerData.Copyright=this.footerData.Copyright.substr(0, 0) + new Date().getFullYear() +" " + this.footerData.Copyright.substr(0);
    let footerCopyRight=this.footerData.Copyright.split(",");
    let copyRightMsg:string;
    footerCopyRight.forEach(copyRight => {
      copyRightMsg= copyRightMsg?copyRightMsg+' © '+new Date().getFullYear()+" "+copyRight:'© '+new Date().getFullYear()+" "+copyRight;
    });
    this.footerData.Copyright=copyRightMsg;
    }

  ngOnInit() {}
}
